export default {
  header: 'Turn off error tracking',
  content:
    'Turning off error tracking mode will delete any current error logs. Do you wish to continue?',
  confirm: 'Turn off',
  cancel: 'Cancel',
} as const;
